<mh-alerts-wrapper>
  <section class="tw-flex tw-flex-row tw-justify-start tw-items-center tw-gap-4 tw-mb-4">
    <div class="tw-min-w-[145px]">
      <mh-core-lib-datepicker
        [currentDates]="currentDates"
        [currentFilter]="currentFilterDate"
        (datepickerUpdated)="handleDatepickerUpdated($event)">
      </mh-core-lib-datepicker>
    </div>
    <mh-box-element *ngIf="fidelityPermissions.includes('interchain_online_summary_result')">
      <mh-core-lib-filter-chain-zone [productId]="productId" [multipleSelectionMode]="true" (chainChanged)="setChain($event)"
        [disabled]="!isReady"></mh-core-lib-filter-chain-zone>
    </mh-box-element>
    <mh-core-lib-filter-hotels [chainFilter]="originalChainFilter" [multipleSelectionMode]="true" (hotelsChanged)="setHotelsFilter($event)"
      [disabled]="isHotelsFilterDisabled"></mh-core-lib-filter-hotels>
  </section>

  <ng-container *ngIf="shouldShowSummary">
    <mh-inter-chain-online-summary 
      [productId]="productId"
      [chain]="chainFilter"
      [currentDates]="currentDates">
    </mh-inter-chain-online-summary>
  </ng-container>
</mh-alerts-wrapper>
